<template>
    <div style="width:100%;">
<div >
      <div class="row" >

        <div class="col-12  col-md-12 col-lg-8 caja-titulo" >
          <h1 class="main-title margenfila" ><!--<span class="titulo" v-html="paginainicio"></span>--></h1>
        </div>
      </div>
      <div class="row" >
        <div v-if="comunicados!=''" id="caja-comunicados" class="col-12 col-md-12 col-lg-12 caja-avisos" >
            <carousel :autoplay="true" :responsive="{0:{items:1,nav:false},600:{items:1,nav:false},800:{items:2,nav:false},1200:{items:3,nav:false}}" :margin="5" > 
          <div v-for="cont in comunicados" :key="cont.id" class="item" >
            <div>
              <!-- <a v-if="cont.TipoRuta=='DOCUMENTO' && cont.AbrirEnVisor==true" v-on:click="AbreElVisor(cont.Ruta)">  <img class="caja-aviso" :src="cont.ImagenComunicado" alt="" /> </a> -->

              <a v-if="cont.TipoRuta=='DOCUMENTO' && cont.AbrirEnVisor==false" v-on:click="AbrirArchivo(cont.Ruta,'_self')">  <img class="caja-aviso" :src="cont.ImagenComunicado" alt="" /> </a> 
             

             <a v-if="cont.TipoRuta=='DOCUMENTO' && cont.AbrirEnVisor==true" v-on:click="AbreElVisor(cont.Ruta)">  <img class="caja-aviso" :src="cont.ImagenComunicado" alt="" /> </a>

             <router-link  v-if="cont.TipoRuta=='RUTAINTERNA'" :to="cont.Ruta">  <img class="caja-aviso" :src="cont.ImagenComunicado" alt="" /> </router-link> 

             <a v-if="cont.TipoRuta=='RUTAEXTERNA'" :href="cont.Ruta" target="_blank">  <img class="caja-aviso" :src="cont.ImagenComunicado" alt="" /> </a>

             <a v-if="cont.TipoRuta=='NOHACERNADA'">  <img class="caja-aviso" :src="cont.ImagenComunicado" alt="" /> </a> 
             
              <p class="tituloComunicado">{{cont.Titulo}}</p>
              <!-- <a v-if="cont.RutaPagina!=null" class="itemPagina" :href="cont.RutaPagina"><i class="fa fa-angle-double-right fa-2x iconoPagina"></i></a> -->
            </div>
        </div>
            </carousel>
        </div>

      </div>
<div class="row">
      <div class="col-12" v-for="(seccion,index) in seccionesHome" :key="index" >
      <div v-if="seccion.TipoFormato.TipoFormatoId == enumeraciones_micrositios.TiposFormatoMicrositios.CajaConVinculo">
      <CajaConVinculo :contenidos="seccion.ContenidoDeMicrositio"></CajaConVinculo>
      </div>
      </div>
</div>
</div>

    </div>
</template>

<script>
import api from '@/../static/js/api'
import axios from 'axios'
 import carousel from 'vue-owl-carousel'
import CajaConVinculo from '@/components/Micrositios/Formatos/CajaConVinculo.vue'
import enumeraciones_micrositios from '@/../static/js/enumeraciones/sicpo.js'
import comun from "@/../static/js/comun";
export default {  
  data(){
    return{
      Comunicados:[],
      enumeraciones_micrositios
    }
  },
    props:{
        seccionesHome:Array,
        comunicados:Array,
        paginainicio:String
    },
    components:{
        CajaConVinculo,
        carousel
        
    },
    methods: {
      
      AbrirArchivo: function(vinculo,forma) {
        if(vinculo!=null && vinculo!="")
            comun.DescargarDocumentoPDF(vinculo);

          //  window.open(vinculo,forma);
        },
      AbreElVisor: function(vinculo) {
      //  console.log("VINCULO::",vinculo)
        this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
        

      },
    },
}
</script>

<style scoped>
/*
 *  STYLE 14
 */

#caja-comunicados::-webkit-scrollbar-track
{
	/* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.6); */
	background-color: #CCCCCC;
}

#caja-comunicados::-webkit-scrollbar
{
	width: 10px;
	background-color: #F5F5F5;
}

#caja-comunicados::-webkit-scrollbar-thumb
{
	background-color: #FFF;
	background-image: -webkit-linear-gradient(90deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) 25%,transparent 100%, rgba(0, 0, 0, 1) 75%,transparent)
}



.iconoPagina{
  margin-top: auto;
  margin-bottom: auto;
     /* width:30px;
       top: auto;
      bottom: auto;
  word-wrap: break-word;
  text-align:center;
  font-size: 1.5em;
  text-transform: uppercase; */

}
.itemPagina:hover{
  /* background-color: red; */
  transform: scale(1.03);
  margin-top: auto;
  margin-bottom:auto;
}

.tituloComunicado{
  font-family: 'AntenaBeta';
  font-size: 1.4em;
}
  
.vinculo{
    display: flex;
    align-items:center;
    justify-content:center;
    color: #FFF;
    background-color: rgba(34,34,34,.8);
    float: left;
    width: 32%;
    height: 80px;
    margin: .5em;
    opacity: 0.8; 
  }

.vinculo h2 {
    color:white;
  }

  
.vinculo h2:hover {
    font-size: 2.8em;
    transition: .6s all;
    }
      
.vinculo:hover{
    background-color: rgba(190,154,94,.9);
    }

.caja-vinculos{
   clear: both;
   width: 100%;
   position: absolute;
   left: 0;
   right: 0;
   bottom: 0%;
   height: 20%;
   z-index: 0;
}

.caja-aviso{
  margin-top:0em;
  height: 30h;
  width: 100%;
  border-radius: 14px;
   
}
.caja-avisos{
 /* height:60vh;*/
  width: 35em;
 /* overflow-y: scroll; */
  /* padding: 4px 30px; */
  border-radius: 14px;

 
}

.contenido-home{
  margin-right: 5em;
}

   
.item{
  position:relative;
  margin-bottom: 1em;

}

.item p{
  position: absolute;
  top: 0;
  left: 0;
  font-weight: bold;
  /* background-color: rgba(73,13,0,1); */
    background-color: rgba(190,154,94,.9);
  color: #FFF;
  padding: 4px 30px;
  border-bottom-right-radius: 14px;
  }
.itemPagina{
  position: absolute;
  display: flex;
  height: 100%;
  top: 0;
  right: 0;
  font-weight: bold;
  /* background-color: rgba(73,13,0,1); */
  background-color: rgba(190,154,94,.9);
  color: #FFF;
  padding: 4px 4px;
  border-bottom-right-radius: 10px; 
  border-top-right-radius: 10px;

  }


.dark-layer2 {
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  /* background-image: url('http://189.206.207.232:85/Files/Micrositios/UIG/Background/unidad%20de%20genero.png');  */
  opacity: 0.6;
  background-position: center;
  background-size: cover;
  position: absolute;;
  }
.AntenaBeta{
    font-family: 'AntenaBeta';   
}
.Myriad{
    font-family:'Myriad';
}

.main-title {
  font-family: 'AntenaBeta';
  /* background-color:rgba(73,13,0,.9);  */
  /* background-color:rgb(106, 106, 106) ; */
  opacity: 0.8;
  border-radius: 20px;
  padding: 4rem 5rem;
  /*padding: 120px 20px; */
  font-size: 5em;
  width: 100%;
  font-weight: bolder;
  color: white;
  text-align: center;
  height: 53vh;
  display: flex;
  align-items: center;
  
  }

  .titulo{
margin :auto;
    /* color: chartreuse; */
    line-height: 1;
        display: inline-block;
        vertical-align: middle;
        text-align: center; /* requerido para volver a alinear texto izquierda */
  }

  .caja-titulo{
    width: 100%;
  }





  @media only screen and (min-width:1467px){
    .margenfila{
  margin-right: .5em;
}
.main-title{
padding-top: 120px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 120px;
     
       
    
}
 

/* .caja-avisos{
  height:70vh;
  width: 35em;
  overflow-y: scroll;
  padding: 4px 30px;
  border-bottom-right-radius: 14px;
} */



  }





    @media only screen and (max-width:1466px){
          .margenfila{
  margin-right: .5em;
}
.main-title{

   height: 130%;
   font-size: 4em;
  
}
.caja-titulo{
      padding-bottom: 59px;
}

    }

  

 @media only screen and (max-width:1300px){
      .margenfila{
  margin-right: 1em;
}
.main-title{
padding-top: 120px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 120px;   
}
.caja-avisos{
  padding-top: 100px;
}

  }





  @media only screen and (max-width:1200px){
        .margenfila{
  margin-right: .5em;
}
.main-title{
padding-top: 120px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 120px;
          
}
.caja-titulo{
      padding-bottom: 39px;
}
.caja-avisos{
  padding-top: 90px;
}

  }





  @media only screen and (max-width:991px){
.main-title{
padding-top: 26px;
    padding-right: 12px;
    padding-left: 7px;
    padding-bottom: 23px;
     height: 4em;
     
}
.item{
     width: 70%;
       margin-right: auto;
     margin-left: auto;
   }
   .caja-avisos{
    padding: 0;
   }


  }

@media only screen and (max-width: 767px){
   .titulo{
font-size: .7em;
   } 



   .main-title{
     height: 8em;
   }
   .caja-avisos{
    padding: 0;
   }
  
   .item{
     width: 70%;
       margin-right: auto;
     margin-left: auto;
   }
     }

  @media only screen and (max-width: 375px){
   .titulo{
font-size: .7em;
   } 

   .main-title{
     height: 4em;
   }

   .item{
     width: 100%;
       margin-right: auto;
     margin-left: auto;
   }
     }

     @media only screen and (max-width: 310px){
   .titulo{
      font-size: .3em;
   } 

   .main-title{
     height: 2em;
    
   }



   .item{
     width: 100%;
       margin-right: auto;
     margin-left: auto;
   }
     }
  
</style>




// WEBPACK FOOTER //
// src/components/Micrositios/HomeMicrositio.vue